import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class FirmaElectronicaSolicitudService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/firma-electronica/solicitud`;
  }

  solicitarFirmaElectronica(medio: 'sms' | 'correo'): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/enviar-token-solicitud/${medio}`, {});
  }

  renovarFirmaElectronica(medio: 'sms' | 'correo'): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/enviar-token-renovacion/${medio}`, {});
  }

  revocacionFirmaElectronica(medio: 'sms' | 'correo'): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/enviar-token-revocacion/${medio}`, {});
  }
}

